export default __webpack_public_path__ + "assets/belarus-flag.png";